import { render, staticRenderFns } from "./BrowserBanner.vue?vue&type=template&id=380b54a0&scoped=true"
import script from "./BrowserBanner.vue?vue&type=script&lang=js"
export * from "./BrowserBanner.vue?vue&type=script&lang=js"
import style0 from "./BrowserBanner.vue?vue&type=style&index=0&id=380b54a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b54a0",
  null
  
)

export default component.exports